export default function ContractorDirectory() {
  const contractors = [
    {
      name: 'Desert Climate HVAC Solutions',
      serviceArea: 'El Paso County, Horizon City, Socorro',
      phone: '(915) 555-0678',
      email: 'info@desertclimatehvac.com',
      yearsInBusiness: '18+ years',
      license: 'TX HVAC License #45678',
      specialties: ['AC Installation', 'Heating Systems', 'Duct Cleaning', 'Energy Audits', 'Emergency Repairs'],
      rating: 4.9,
      reviews: 387,
      image: 'https://public.readdy.ai/ai/img_res/fc57365ca1d0d9c3bc8c98bc2d4a74e5.jpg',
      certifications: ['NATE Certified', 'EPA Certified', 'Carrier Factory Authorized'],
      insurance: 'Fully Licensed & Insured',
      warranty: '10-Year Parts & Labor Warranty',
      description: 'Family-owned HVAC company specializing in residential and commercial climate control throughout El Paso. Expert in desert climate HVAC solutions with extensive experience in energy-efficient systems. Known for reliable service and 24/7 emergency response.'
    },
    {
      name: 'Franklin Mountain Heating & Cooling',
      serviceArea: 'West El Paso, East El Paso, Upper Valley',
      phone: '(915) 555-0901',
      email: 'contact@franklinhvac.com',
      yearsInBusiness: '25+ years',
      license: 'TX HVAC License #90123',
      specialties: ['Central AC Systems', 'Heat Pump Installation', 'Indoor Air Quality', 'Smart Thermostats', 'Maintenance Plans'],
      rating: 5.0,
      reviews: 421,
      image: 'https://readdy.ai/api/search-image?query=Established%20HVAC%20contractor%20company%20in%20El%20Paso%2C%20skilled%20master%20HVAC%20technicians%20in%20professional%20work%20gear%20with%20advanced%20diagnostic%20tools%20and%20equipment%2C%20company%20branded%20trucks%20with%20ladders%20and%20supplies%2C%20completed%20HVAC%20installation%20visible%2C%20Franklin%20Mountains%20in%20background%2C%20professional%20business%20photography%20showing%20experienced%20reliable%20HVAC%20team&width=500&height=350&seq=contractor-dir-hvac-101&orientation=landscape',
      certifications: ['BBB A+ Rating', 'Trane Comfort Specialist', 'ACCA Certified'],
      insurance: 'Licensed, Bonded & Insured',
      warranty: 'Lifetime Service Guarantee',
      description: 'El Paso\'s most trusted HVAC contractor with over two decades of experience. Specializes in high-efficiency heating and cooling systems with expert installation and maintenance. Award-winning service with same-day emergency repairs and preventive maintenance programs.'
    }
  ];

  return (
    <section id="directory" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Licensed HVAC Contractors Directory
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Connect with verified, licensed HVAC professionals serving El Paso. Each contractor has been vetted for licensing, insurance, and customer satisfaction.
          </p>
        </div>

        <div className="space-y-8">
          {contractors.map((contractor, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 hover:border-teal-500 transition-all overflow-hidden">
              <div className="grid md:grid-cols-3 gap-6 p-6">
                <div className="md:col-span-1">
                  <div className="relative h-64 md:h-full rounded-lg overflow-hidden mb-4 md:mb-0">
                    <img 
                      src={contractor.image} 
                      alt={contractor.name}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-3 right-3">
                      <span className="px-3 py-1 bg-teal-600 text-white text-xs font-bold rounded-full">
                        Featured
                      </span>
                    </div>
                  </div>
                </div>

                <div className="md:col-span-2">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2">{contractor.name}</h3>
                      <div className="flex items-center gap-2 mb-2">
                        <div className="flex items-center gap-1">
                          <i className="ri-star-fill text-yellow-400"></i>
                          <span className="text-sm font-semibold text-gray-900">{contractor.rating}</span>
                        </div>
                        <span className="text-sm text-gray-500">({contractor.reviews} reviews)</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-sm text-gray-700 mb-4 leading-relaxed">{contractor.description}</p>

                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="space-y-2">
                      <div className="flex items-start gap-2">
                        <i className="ri-map-pin-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Service Area</p>
                          <p className="text-xs text-gray-600">{contractor.serviceArea}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-phone-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Contact</p>
                          <p className="text-xs text-gray-600">{contractor.phone}</p>
                          <p className="text-xs text-gray-600">{contractor.email}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-time-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Experience</p>
                          <p className="text-xs text-gray-600">{contractor.yearsInBusiness}</p>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <div className="flex items-start gap-2">
                        <i className="ri-shield-check-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">License Number</p>
                          <p className="text-xs text-gray-600">{contractor.license}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-file-shield-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Insurance</p>
                          <p className="text-xs text-gray-600">{contractor.insurance}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-award-line text-teal-600 mt-0.5"></i>
                        <div>
                          <p className="text-xs font-semibold text-gray-900">Warranty</p>
                          <p className="text-xs text-gray-600">{contractor.warranty}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <p className="text-xs font-semibold text-gray-900 mb-2">Specialties</p>
                    <div className="flex flex-wrap gap-2">
                      {contractor.specialties.map((specialty, i) => (
                        <span key={i} className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <p className="text-xs font-semibold text-gray-900 mb-2">Certifications</p>
                    <div className="flex flex-wrap gap-2">
                      {contractor.certifications.map((cert, i) => (
                        <span key={i} className="px-3 py-1 bg-teal-50 text-teal-700 text-xs rounded-full flex items-center gap-1">
                          <i className="ri-checkbox-circle-fill"></i>
                          {cert}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8">
          <h3 className="text-2xl font-bold mb-3 text-white text-center">
            Have a Pro Contact You
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto text-center">
            Get connected with qualified HVAC professionals in your area. Fill out the form below and receive responses from licensed contractors.
          </p>
          <form 
            id="contact-form-hvac"
            data-readdy-form
            action="https://readdy.ai/api/form/d5u65hes8bb84h5iea7g"
            method="POST"
            className="max-w-2xl mx-auto bg-white rounded-lg p-6"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              const data = new URLSearchParams();
              
              formData.forEach((value, key) => {
                data.append(key, value.toString());
              });

              fetch(form.action, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: data.toString()
              })
              .then(response => {
                if (response.ok) {
                  alert('Thank you! A professional will contact you soon.');
                  form.reset();
                } else {
                  alert('Something went wrong. Please try again.');
                }
              })
              .catch(() => {
                alert('Something went wrong. Please try again.');
              });
            }}
          >
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="John Smith"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-1">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="john@example.com"
                />
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-1">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="(915) 555-0123"
                />
              </div>
              <div>
                <label htmlFor="zip" className="block text-sm font-semibold text-gray-900 mb-1">
                  Zip Code *
                </label>
                <input
                  type="text"
                  id="zip"
                  name="zip"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                  placeholder="79901"
                />
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="project" className="block text-sm font-semibold text-gray-900 mb-1">
                Project Details *
              </label>
              <textarea
                id="project"
                name="project"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                placeholder="Describe your HVAC project..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
            </div>
            <button
              type="submit"
              className="w-full px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap"
            >
              Submit Request
            </button>
          </form>
        </div>

        <div className="mt-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-3">
            Are You a Licensed HVAC Contractor?
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Join our directory and connect with homeowners actively searching for HVAC services in El Paso. Featured listings receive priority placement and generate qualified leads.
          </p>
          <a href="#list-service" className="inline-block px-8 py-3 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap">
            List Your HVAC Business
          </a>
        </div>
      </div>
    </section>
  );
}